module.exports = __webpack_public_path__ + "static/media/register_wario.ae90f6ce.png";